module.exports = __webpack_public_path__ + "assets/ic_weather03.87058120.svg";